import { NgFor, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { UtilsService } from '../../Services/utils.service';
import { WebSocketService } from '../../Services/web-socket.service';
import { LogoutmodelComponent } from '../header/logoutmodel/logoutmodel.component';

@Component({
  selector: 'app-profile-sidebar',
  imports: [RouterLink, NgFor, NgClass, LogoutmodelComponent],
  templateUrl: './profile-sidebar.component.html',
  styleUrl: './profile-sidebar.component.scss',
})
export class ProfileSidebarComponent {
  profileImage = 'https://cmax-2.pages.dev/assets/icons/profileimage.png';
  constructor(
    public router: Router,
    private utilService: UtilsService,
    private _socketService: WebSocketService,
  ) {
    //? Profile Image Dynamic Update
    this.utilService.profileImage$.subscribe((image) => {
      this.profileImage = image;
    });
  }
  logout() {
    localStorage.clear();
    this._socketService.close();
    this.router.navigate(['/']);
    this.utilService.toggleComponentVisibility(false);
    // if (this._socketService.isConnected) {
    // }
    this.closeLogoutModal();
  }

  closeLogoutModal() {
    this.isLogoutModalOpen = false;
  }

  isLogoutModalOpen: boolean = false;
  sidebarData = [
    {
      title: 'My Profile',
      isActive: false,
      iconClass: 'far fa-user',
      redirectUrl: '/dashboard-user-profile',
    },
    {
      title: 'Security',
      isActive: false,
      iconClass: 'fas fa-lock',
      redirectUrl: '/dashboard-user-security',
    },
    {
      title: 'KYC Verification',
      isActive: false,
      iconClass: 'fas fa-user-lock',
      redirectUrl: '/dashboard-user-kyc',
    },
    {
      title: 'Term & Conditions',
      isActive: false,
      iconClass: 'fas fa-file-contract',
      redirectUrl: '/dashboard-user-terms',
    },
    {
      title: 'Logout',
      isActive: false,
      iconClass: 'fas fa-sign-out-alt',
      redirectUrl: '/login',
    },
  ];
  redirectUrl(route: string) {
    this.router.navigate([route]);
  }
}
